import { render, staticRenderFns } from "./listStatusConfig.vue?vue&type=template&id=45af7ff9&scoped=true"
import script from "./listStatusConfig.vue?vue&type=script&lang=js"
export * from "./listStatusConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af7ff9",
  null
  
)

export default component.exports